export default __webpack_public_path__ + "static/media/news92.31c0a177.jpg";